export { default } from './SeguroAuto25PortalApp';
